export function postAd(payload: object) {
  const formData = new FormData();
  for (const [key, value] of Object.entries(payload)) {
    formData.append(key, value);
  }

  return fetch('/api/messages', {
    body: formData,
    method: 'POST',
  });
} 

export function verifyAd(externalId: string, auth: string) {
  return fetch(`/api/messages/${externalId}/auth/${auth}/verify`, {
    method: 'POST',
  });
}

export function deleteAd(externalId: string, auth: string) {
  return fetch(`/api/messages/${externalId}/auth/${auth}`, {
    method: 'DELETE',
  });
}

export function reply(externalId: string, payload: object) {
  const formData = new FormData();
  for (const [key, value] of Object.entries(payload)) {
    formData.append(key, value);
  }

  return fetch(`/api/messages/${externalId}/replies`, {
    body: formData,
    method: 'POST',
  });
}
